import Logo1 from "../assets/icons/SentinelVPN.svg";
import Logo2 from "../assets/icons/IndependentVPN.svg";
import Logo3 from "../assets/icons/norse-logo.svg";
import Logo4 from "../assets/icons/valt-icon.svg";
import Logo5 from "../assets/icons/meile.svg";
import Logo6 from "../assets/icons/SolarDVPN.svg";


import SentinelMobileImg from "../assets/images/sentinel-mobile.png";
import BagimsizMobileImg from "../assets/images/bagimsiz-mobile.png";
import ValtMobileImg from "../assets/images/valt-mobile.png";
import MeileMobileImg from "../assets/images/meile-dvpn-mobile.png";
import SolarMobileImg from '../assets/images/solar-mobile.png'
import NorseMobileImg from '../assets/images/norse-mobile.png'
import DVPNBotMobileImg from '../assets/images/dvpnbot-mobile.png'

const constants = [
  {
    logo: Logo1,
    title: "Sentinel Shield dVPN",
    description: "The flagship VPN product built on the Sentinel network allowing for users to directly interact with nodes using the Sentinel Blockchain",
    isSentinel: true,
    img: SentinelMobileImg,
    btn: {
      title: "Download Now",
      link: "https://shield.sentinel.co/",
    },
    details: {
      android: "https://play.google.com/store/apps/details?id=co.sentinel.dvpnapp",
      ios: "https://apps.apple.com/app/sentinel-shield-dvpn/id6657986086",
    },
  },
  {
    logo: Logo2,
    title: "Independent VPN",
    description: "A free VPN that gives the people of Turkey access to the open internet.",
    isSentinel: false,
    img: BagimsizMobileImg,
    btn: {
      title: "Download Now",
      link: "https://independentdvpn.com/",
    },
  },
  {
    logo: Logo3,
    title: "DVPN by NORSE",
    description: "World's most advanced and user-friendly decentralized VPN.",
    isSentinel: false,
    img: NorseMobileImg,
    btn: {
      title: "Download Now",
      link: "https://norselabs.io/products/dvpn",
    },
  },
  {
    logo: Logo4,
    title: "VALT",
    description: "VALT is the only app available that allows you to capture and protect the data you create everyday.",
    isSentinel: false,
    img: ValtMobileImg,
    btn: {
      title: "Download Now",
      link: "https://valtdata.com/",
    },
  },
  {
    logo: Logo5,
    title: "Meile dVPN",
    description: "Meile dVPN combines blockchain technology and decentralized nodes for unbeatable privacy and internet freedom.",
    isSentinel: false,
    img: MeileMobileImg,
    btn: {
      title: "Download Now",
      link: "https://mathnodes.com/index.php/meile-dvpn-client-linux-os-x/",
    },
  },
  {
    logo: Logo6,
    title: "Solar dVPN",
    description: "SOLAR dVPN is a fully decentralised VPN service built and managed by the team at SOLAR LABS.",
    isSentinel: false,
    img: SolarMobileImg,
    btn: {
      title: "Download Now",
      link: "https://dvpn.solar/",
    },
  },
    {
    logo: Logo3,
    title: "DVPN Bot",
    description: "World's first decentralized VPN available in Telegram.",
    isSentinel: false,
    img: DVPNBotMobileImg,
    btn: {
      title: "Download Now",
      link: "https://norselabs.io/products/dvpn-bot",
    },
  },
];
export default constants;
